export const NOVU_ENCRYPTION_SUB_MASK = 'nvsk.';
export var ShortIsPrefixEnum;
(function (ShortIsPrefixEnum) {
    ShortIsPrefixEnum["WORKFLOW"] = "wf_";
    ShortIsPrefixEnum["STEP"] = "st_";
    ShortIsPrefixEnum["ENVIRONMENT"] = "env_";
})(ShortIsPrefixEnum || (ShortIsPrefixEnum = {}));
